<template>
  <!-- 订单详情，暂时不用 -->
  <el-card class="box-card">
    <div class="detail-header">
      <el-page-header @back="goBack()"
                      title="返回"
                      content="订单详情"></el-page-header>
    </div>
    <!-- 订单状态 -->
    <div class="step-content">
      <el-steps :active="4"
                align-center>
        <el-step title="未处理"
                 description="客人已下单，需要安排预定"></el-step>
        <el-step title="等待确认"
                 description="已发送预定信息给供应商，等待供应商确认"></el-step>
        <el-step title="等待出行"
                 description="供应商已接收并确认订单，等待客人出行"></el-step>
        <el-step title="已完成"
                 description="客人行程已结束"></el-step>
      </el-steps>
    </div>
    <!-- 订单信息 -->
    <div class="detail">
      <div class="detail-info">
        <h2>订单信息</h2>
        <ul>
          <li>
            <b>订单来源:</b>
            <span>{{ota_source}}</span>
          </li>
          <li>
            <b>平台单号:{{booking_num}}</b>
          </li>
          <li>
            <b @click="clickHandle()">订单编号:</b>
          </li>
          <li>
            <b>下单日期:</b>
          </li>
          <li>
            <b>平台订单状态:</b>
            <span>{{ota_status}}</span>
          </li>
        </ul>
      </div>
      <div class="line-info"></div>
      <div class="detail-info">
        <h2>费用详情</h2>
        <ul>
          <li>
            <b>订单总价:</b>
            <span>{{total_fee}}</span>
          </li>
          <li>
            <b>优惠金额:</b>
          </li>
        </ul>
      </div>
    </div>

    <!-- 活动信息 -->
    <div class="detail-active">
      <div class="active-info">
        <h2>活动信息</h2>
        <div class="line-active"></div>

        <p>{{product_name}}</p>
        <p>所选套餐：</p>
        {{package_name}}
        <p>活动日期：</p>
        {{trip_start_date}}
        <p>出行人数：</p>
        {{num}}
      </div>
      <!-- ------------ -->

      <div class="active-transfer">
        <h2>接送信息</h2>
        <div class="line-active"></div>
        <p>出发时间：</p>
        <p>出发地名称</p>
        <p>出发地地址</p>
        <p>出发地联系方式</p>
        <p>送达地名称</p>
        <p>送达地地址</p>
        <p>送达地联系方式</p>
      </div>
    </div>

    <!-- 联系人信息 -->
    <div class="detail">
      <div class="contact-detail">
        <h2>联系人信息</h2>
        <div class="line-active"></div>
        <p>联系人姓名</p>
        <p>姓名拼音</p>
        <p>联系电话</p>
        <p>联系人微信</p>
        <p>邮箱</p>
      </div>
    </div>
    <!-- 出行人信息 -->
    <div class="detail">
      <div class="join-detail">
        <h2>出行人信息</h2>
        <div class="line-active"></div>
        <div class="join-card-info">
          <!-- <traver-cards></traver-cards> -->
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
// import cards from '../../components/common/cards/cards'
export default {
  name: 'BookingDetail',
  // components: { 'traver-cards': cards },
  data() {
    return {
      ota_source: '',
      product_name: '',
      package_name: '',
      num: '',
      price_per: '',
      total_fee: '',
      trip_start_date: '',
      seller_memo: '',
      ota_status: '',

      pick_name: '',
      pick_address: '',
      pick_tell: '',
      room_no: '',
      drop_name: '',
      drop_address: '',
      drop_tell: '',

      name: '',
      name_pinyin: '',
      phone: '',
      sns: '',
      email: '',

      traverllers: [
        {
          name: '',
          name_en: '',
          phone: '',
          credential_type: '',
          credential_no: '',
        },
      ],
    }
  },
  props: ['booking_num'],

  mounted() {
    this.getDetial()
  },
  updated() {
    this.getDetial()
  },
  methods: {
    // 发送获取订单详情的请求：
    getDetial() {
      this.$http
        .get(`booking/fly_detail?bookingID=${this.booking_num}`)

        // .get(`list/fly_detail?bookingID=593707911250774198`)
        .then((res) => {
          console.log(res)

          const { data, errno, errmsg } = res.data
          if (errno == 0) {
            this.ota_source = data.about_booking.ota_source
            this.num = data.about_booking.num
            this.price_per = data.about_booking.goods_price
            this.total_fee = data.about_booking.total_fee
            this.product_name = data.about_booking.product_name
            this.package_name = data.about_booking.package_name
            this.trip_start_date = data.about_booking.trip_start_date
            this.seller_memo = data.about_booking.seller_memo
            this.ota_status = data.about_booking.ota_status
            this.num = data.about_booking.num
            this.pick_name = data.about_booking.ota_source
            this.pick_address = data.about_booking.ota_source
            this.pick_tell = data.about_booking.ota_source
            this.room_no = data.about_booking.ota_source
            this.drop_name = data.about_booking.ota_source
            this.drop_address = data.about_booking.ota_source
            this.drop_tell = data.about_booking.ota_source
            this.name = data.about_booking.ota_source
            this.name_pinyin = data.about_booking.ota_source
            this.phone = data.about_booking.ota_source
            this.sns = data.about_booking.ota_source
            this.email = data.about_booking.ota_source
          }
        })
    },
    // 关闭抽屉
    goBack() {
      // this.$parent.closeDrawer();
      this.$router.push({ path: '/booking_list' })
    },
    clickHandle() {
      // console.log(this.a);
      // console.log(this.booking_num);
    },
  },
}
</script>

<style>
.detail-header {
  font-size: 5px;
}

.el-page-header {
  font-size: 5px;
}

div.el-page-header__content {
  font-size: 13px;
}

.step-content {
  margin-top: 20px;
  padding: 50px;
  border: 5px;
  background-color: cornsilk;
}

.detail {
  display: flex;
  align-content: center;
  /* justify-content: center; */
  background-color: cornsilk;
  margin: 10px 0px;
  padding: 10px 10px;
  border-radius: 2px;
  /* border: 1px solid #d7dae2; */
  width: auto;
  height: auto;
}

.detail-info {
  padding: 5px 0 30px 10px;
  display: block;
  width: 100%;
  text-align: left;
  font-weight: lighter;
}

.line-info {
  height: auto;
  width: 1px;
  background-color: #d7dae2;
  margin: 0 10px;
}

.detail-active {
  align-content: center;
  background-color: cornsilk;
  margin: 10px 0px;
  padding: 10px 10px;
  border-radius: 2px;
  /* border: 1px solid #d7dae2; */
  width: auto;
  height: auto;
}

.active-info {
  padding: 5px 10px 30px 10px;
  display: block;
  width: auto;
  text-align: left;
  font-weight: lighter;
}

.active-transfer {
  padding: 5px 10px 30px 10px;
  display: block;
  width: auto;
  text-align: left;
  font-weight: lighter;
}

.line-active {
  height: 1px;
  width: 100%;
  background-color: #e4e6eb;
  margin-bottom: 10px;
}

.contact-detail {
  padding: 5px 10px 30px 10px;
  display: block;
  width: 100%;
  text-align: left;
  font-weight: lighter;
}

/* 出行人样式 */
.join-detail {
  padding: 5px 10px 30px 10px;
  display: block;
  width: 100%;
  text-align: left;
  font-weight: lighter;
}

/* 出行人盒子的父盒子 */
.join-card-info {
  display: flex;
  height: 100%;
  flex-flow: row wrap;
  justify-content: space-between;
}

/* .join-card {
    box-sizing: border-box;
    padding: 10px;
    margin-bottom: 15px;
    background-color: white;
    border-radius: 2px;
    flex: 0 0 32%
  } */
</style>